'use strict';

let KeyCode = new KeyCodeHandler();

function KeyCodeHandler() {
    this.vueComponent;
    this.pressedKeyCodeMap = {};

    this.SaveHandler = null;
}



KeyCodeHandler.prototype.Attach = function (vueComponent) {

    this.vueComponent = vueComponent;
    this.SetKeyEventHandler();
}//end PageUtility.AttachBlock = function (elementId) {


KeyCodeHandler.prototype.SetKeyEventHandler = function () {
    document.body.onkeydown = function (e) {
        KeyCode.OnKeyDown(e);
    }.bind(this);

    document.body.onkeyup = function (e) {
        KeyCode.OnKeyUp(e);
    }.bind(this);
}//end KeyCodeHandler.prototype.SetKeyEventHandler = function () {


KeyCodeHandler.prototype.OnKeyDown = function (e) {
    let saveButtonElement;

    this.pressedKeyCodeMap[event.keyCode] = true;

    if (this.pressedKeyCodeMap[17] && this.pressedKeyCodeMap[83]) {

        this.pressedKeyCodeMap[17] = false;
        this.pressedKeyCodeMap[83] = false;



        if (this.SaveHandler != null) {
            e.preventDefault();
            this.SaveHandler();
        }else if (this.vueComponent != null && this.vueComponent.OnSaveButtonClick != null) {
            e.preventDefault();
             

            setTimeout(
                () => {
                    this.vueComponent.OnSaveButtonClick();
                },
                100
            );
        }
 

        return false;
    }
}//end KeyCode.OnKeyDown = function () {


KeyCodeHandler.prototype.OnKeyUp = function (e) {
    this.pressedKeyCodeMap[event.keyCode] = false;
}


export {
    KeyCodeHandler
}

export default KeyCode;
